export default (payload) => ({
  type: 'NEW_LOAN_STATE',
  payload,
});
